module.exports = __webpack_public_path__ + "img/portfolio-02.57e17a61.jpg";